<template>
  <header class="header">
    <card-background class="header__wrapper" :class="{'header__wrapper_padding': isModerationRoute}">
      <div class="header__line">
        <router-link class="link" :to="{ name: 'tasks' }">
          <div class="logo__wrapper">
            <img src="@/assets/brand/kazatel__logo_header.png" class="logo" alt="Казатель"/>
            <span class="heading heading_size_h3">Казатель</span>
          </div>
        </router-link>
        <div class="header__info">
          <ul class="header-soc">
            <li>
              <a href="https://vk.com/kazatel_su" class="header-soc__link" target="_blank" title="ВК">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><g clip-path="url(#a)">
                  <path fill="currentColor" fill-opacity=".9" d="m12.652.005.972-.004h4.752l.973.004 1.219.014.577.009.558.015.537.018.517.022.499.028.48.033.46.04.444.044c2.32.261 3.91.821 5.11 2.021 1.2 1.2 1.76 2.79 2.022 5.11l.045.445.039.461.033.48.027.498.033.784.016.546.018.859.012 1.22.005 1.307-.001 4.417-.004.973-.014 1.219-.009.577-.015.558-.018.537-.022.517-.028.499-.033.48-.04.46-.044.444c-.261 2.32-.821 3.91-2.021 5.11-1.2 1.2-2.79 1.76-5.111 2.022l-.444.045-.461.039-.48.033-.498.027-.784.033-.546.016-.859.018-1.22.012-1.307.005-4.417-.001-.973-.004-1.219-.014-.577-.01-.558-.014-.537-.018-.517-.022-.499-.028-.48-.033-.46-.04-.444-.044c-2.32-.261-3.91-.821-5.11-2.021-1.2-1.2-1.76-2.79-2.022-5.111l-.045-.444-.039-.461-.033-.48-.027-.498-.033-.784-.016-.546-.018-.86-.012-1.22L0 18.042l.001-4.417.004-.973.014-1.22.009-.576.015-.558.018-.537.022-.517.028-.5.033-.48.04-.46.044-.443c.261-2.32.821-3.91 2.021-5.11C3.45 1.05 5.04.49 7.36.227l.444-.045.461-.04.48-.032.498-.027.784-.033.546-.016.859-.018 1.22-.012ZM9.053 9.733H5.4c.173 8.32 4.333 13.32 11.627 13.32h.413v-4.76c2.68.267 4.707 2.227 5.52 4.76h3.787c-1.04-3.786-3.774-5.88-5.48-6.68 1.706-.986 4.106-3.386 4.68-6.64h-3.44c-.747 2.64-2.96 5.04-5.067 5.267V9.733H14v9.227c-2.133-.533-4.827-3.12-4.947-9.227Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://t.me/kazatel_su" class="header-soc__link" target="_blank" title="Телеграм">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
                  <g clip-path="url(#a)"><path fill="currentColor" fill-opacity=".9" d="M32 16A15.9999 15.9999 0 0 1 4.6863 27.3137 16 16 0 1 1 32 16Zm-15.426-4.188c-1.5573.648-4.668 1.988-9.332 4.02-.756.3-1.1527.5947-1.19.884-.06.486.55.678 1.38.94l.35.11c.816.266 1.916.576 2.486.588.52.0133 1.0987-.2 1.736-.64 4.3587-2.9413 6.608-4.428 6.748-4.46.1-.024.24-.052.332.032.092.084.084.24.074.282-.06.258-2.454 2.482-3.692 3.634-.386.36-.66.614-.716.672a15.8895 15.8895 0 0 1-.376.372c-.76.732-1.328 1.28.03 2.176.654.432 1.178.786 1.7 1.142.568.388 1.136.774 1.872 1.258.1867.1227.3667.2473.54.374.662.472 1.26.896 1.994.828.428-.04.87-.44 1.094-1.64.53-2.834 1.572-8.972 1.812-11.502a2.7967 2.7967 0 0 0-.026-.63.68.68 0 0 0-.228-.434 1.06 1.06 0 0 0-.62-.186c-.6.01-1.526.332-5.968 2.18Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://dzen.ru/kazatel" class="header-soc__link" target="_blank" title="Яндекс Дзен">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
                  <g clip-path="url(#a)"><mask id="b" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M31.888 0H.0698v31.8182H31.888V0Z"/></mask><g mask="url(#b)"><path fill="currentColor" fill-opacity=".9" d="M15.9117 31.8125h.1269c6.3175 0 9.9844-.636 12.5819-3.1577 2.6484-2.675 3.26-6.3667 3.26-12.6596v-.1779c0-6.291-.6116-9.958-3.26-12.6595C26.0249.636 22.3315 0 16.0405 0h-.1269C9.5962 0 5.9272.6361 3.3298 3.1578.6813 5.8328.0698 9.5263.0698 15.8173v.1779c0 6.291.6115 9.9581 3.26 12.6596 2.5728 2.5217 6.2664 3.1577 12.5819 3.1577Z"/><path fill="#fff" d="M28.0936 15.6648c0-.1211-.0985-.2215-.2197-.2271-4.348-.1647-6.9942-.7193-8.8454-2.5706-1.8551-1.855-2.4079-4.5032-2.5726-8.8607a.2275.2275 0 0 0-.2271-.2195h-.5073c-.1211 0-.2215.0984-.2271.2195-.1647 4.3556-.7175 7.0057-2.5725 8.8607-1.8531 1.8532-4.4975 2.4059-8.8455 2.5706a.2276.2276 0 0 0-.2196.2271v.5073c0 .1212.0984.2215.2196.2272 4.348.1646 6.9942.7193 8.8455 2.5705 1.8512 1.8513 2.404 4.492 2.5706 8.8322a.2276.2276 0 0 0 .2271.2197h.5092c.1211 0 .2215-.0985.2271-.2197.1666-4.3402.7194-6.9809 2.5707-8.8322 1.8531-1.8531 4.4974-2.4059 8.8454-2.5705a.2277.2277 0 0 0 .2197-.2272v-.5073h.0019Z"/></g></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs>
                </svg>
              </a>
            </li>
          </ul>
          <Button
            v-if="!sessionActive"
            :label="'Войти в Казатель'"
            :size="'M'"
            :appearance="'outline'"
            :mode="'normal'"
            :rightIcon="true"
            :rightIconName="'kuiIconLoginLarge'"
            @click="goToLogin"
            class="login__button"
          />
          <div v-else class="header__user-wrapper">
            <avatar
              class="avatar"
              :class="{'avatar_type_active': isPersonalInfoRoute}"
              :size="'S'"
              :avatarImage="getSrcAvatar"
              @click="goToSettings"
            />
            <Button
              class="menu"
              :label="''"
              :size="'M'"
              :appearance="'flat'"
              :mode="'onLight'"
              :rightIcon="true"
              :rightIconName="burgerVisibility ? 'kuiIconCloseLarge'  : 'kuiIconMenuLarge'"
              @click="toggleMenu"
            />
            <KazDropdown positionX="right" ref="header_menu">
              <template v-slot:button>
                <Button
                  :label="''"
                  :size="'M'"
                  :appearance="'flat'"
                  :mode="'onLight'"
                  :rightIcon="true"
                  :rightIconName="'kuiIconChevronDownLarge'"
                />
              </template>
              <template v-slot:menu>
                <li
                  v-for="(item, index) in dropdownItems"
                  class="dropdown__item dropdown__item_type_content dropdown__item_size_M"
                  :key="index" 
                  @click="e => { $refs.header_menu.hideMenu(); item.action();}"
                >
                  {{ item.title }}
                </li>
              </template>
            </KazDropdown>
          </div>
        </div>
        <div class="header__line_mobile" v-if="!sessionActive">
          <Button
            v-if="!sessionActive"
            :label="''"
            :size="'M'"
            :appearance="'outline'"
            :mode="'normal'"
            :rightIcon="true"
            :rightIconName="'kuiIconLoginLarge'"
            @click="goToLogin"
          />
          <Button
            class="menu"
            :label="''"
            :size="'M'"
            :appearance="'flat'"
            :mode="'onLight'"
            :rightIcon="true"
            :rightIconName="burgerVisibility ? 'kuiIconCloseLarge'  : 'kuiIconMenuLarge'"
            @click="toggleMenu"
          />
        </div>
      </div>
      <hr class="dropdown__item_type_divider" v-if="!isModerationRoute"/>
      <div class="header__line header__search" v-if="!isModerationRoute">
        <nav 
          class="header__navigation" 
          ref="searchBookAnchor" 
        >
          <router-link
            :to="{ name: item.link.included[0]}"
            v-for="(item, index) in filteredSubHeaderArray" :key="index"
            :class="{ 'navigation__item_active': isLinkActive(item.link) }"
          >
            <div 
              class="navigation__item" 
              :class="{ 'navigation__item_badge': item.badge.name }"
            >
              <p class="label label_size_M" v-if="!item.badge.name">{{ item.title }}</p>
              <kaz-badge
                v-if="item.badge.name"
                :label="item.title"
                :appearance="'accent'"
              />
            </div>
          </router-link>
        </nav>
        <div
          v-if="windowWidth > 768" 
          class="header__search-wrapper" ref="searchBookInput"
        >
          <SearchBookInput v-show="showSearchBookWidget"/>
        </div>
      </div>
      <div v-if="burgerVisibility && windowWidth <= 768" class="menu__wrapper">
        <nav class="mobile__navigation">
          <router-link
            :to="{ name: item.link.included[0]}"
            v-for="(item, index) in filteredSubHeaderArray" :key="index"
            :class="{ 'navigation__item_active': isLinkActive(item.link) }"
          >
            <div 
              class="navigation__item" 
              :class="{ 'navigation__item_badge': item.badge.name }"
            >
              <p
                v-if="!item.badge.name"
                class="label label_size_M"
              >
                {{ item.title }}
              </p>
              <kaz-badge
                v-else="item.badge.name"
                :label="item.title"
                :appearance="'accent'"
                :size="'M'"
              />
            </div>
          </router-link>
        </nav>
        <div v-if="windowWidth <= 768" class="header__search-wrapper_mobile">
          <SearchBookInput v-show="showSearchBookWidget"/>
        </div>
        <ul class="header-soc header-soc_mobile">
          <li>
            <a href="https://vk.com/kazatel_su" class="header-soc__link" target="_blank" title="ВК">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><g clip-path="url(#a)">
                <path fill="currentColor" fill-opacity=".9" d="m12.652.005.972-.004h4.752l.973.004 1.219.014.577.009.558.015.537.018.517.022.499.028.48.033.46.04.444.044c2.32.261 3.91.821 5.11 2.021 1.2 1.2 1.76 2.79 2.022 5.11l.045.445.039.461.033.48.027.498.033.784.016.546.018.859.012 1.22.005 1.307-.001 4.417-.004.973-.014 1.219-.009.577-.015.558-.018.537-.022.517-.028.499-.033.48-.04.46-.044.444c-.261 2.32-.821 3.91-2.021 5.11-1.2 1.2-2.79 1.76-5.111 2.022l-.444.045-.461.039-.48.033-.498.027-.784.033-.546.016-.859.018-1.22.012-1.307.005-4.417-.001-.973-.004-1.219-.014-.577-.01-.558-.014-.537-.018-.517-.022-.499-.028-.48-.033-.46-.04-.444-.044c-2.32-.261-3.91-.821-5.11-2.021-1.2-1.2-1.76-2.79-2.022-5.111l-.045-.444-.039-.461-.033-.48-.027-.498-.033-.784-.016-.546-.018-.86-.012-1.22L0 18.042l.001-4.417.004-.973.014-1.22.009-.576.015-.558.018-.537.022-.517.028-.5.033-.48.04-.46.044-.443c.261-2.32.821-3.91 2.021-5.11C3.45 1.05 5.04.49 7.36.227l.444-.045.461-.04.48-.032.498-.027.784-.033.546-.016.859-.018 1.22-.012ZM9.053 9.733H5.4c.173 8.32 4.333 13.32 11.627 13.32h.413v-4.76c2.68.267 4.707 2.227 5.52 4.76h3.787c-1.04-3.786-3.774-5.88-5.48-6.68 1.706-.986 4.106-3.386 4.68-6.64h-3.44c-.747 2.64-2.96 5.04-5.067 5.267V9.733H14v9.227c-2.133-.533-4.827-3.12-4.947-9.227Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://t.me/kazatel_su" class="header-soc__link" target="_blank" title="Телеграм">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
                <g clip-path="url(#a)"><path fill="currentColor" fill-opacity=".9" d="M32 16A15.9999 15.9999 0 0 1 4.6863 27.3137 16 16 0 1 1 32 16Zm-15.426-4.188c-1.5573.648-4.668 1.988-9.332 4.02-.756.3-1.1527.5947-1.19.884-.06.486.55.678 1.38.94l.35.11c.816.266 1.916.576 2.486.588.52.0133 1.0987-.2 1.736-.64 4.3587-2.9413 6.608-4.428 6.748-4.46.1-.024.24-.052.332.032.092.084.084.24.074.282-.06.258-2.454 2.482-3.692 3.634-.386.36-.66.614-.716.672a15.8895 15.8895 0 0 1-.376.372c-.76.732-1.328 1.28.03 2.176.654.432 1.178.786 1.7 1.142.568.388 1.136.774 1.872 1.258.1867.1227.3667.2473.54.374.662.472 1.26.896 1.994.828.428-.04.87-.44 1.094-1.64.53-2.834 1.572-8.972 1.812-11.502a2.7967 2.7967 0 0 0-.026-.63.68.68 0 0 0-.228-.434 1.06 1.06 0 0 0-.62-.186c-.6.01-1.526.332-5.968 2.18Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://dzen.ru/kazatel" class="header-soc__link" target="_blank" title="Яндекс Дзен">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
                <g clip-path="url(#a)"><mask id="b" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M31.888 0H.0698v31.8182H31.888V0Z"/></mask><g mask="url(#b)"><path fill="currentColor" fill-opacity=".9" d="M15.9117 31.8125h.1269c6.3175 0 9.9844-.636 12.5819-3.1577 2.6484-2.675 3.26-6.3667 3.26-12.6596v-.1779c0-6.291-.6116-9.958-3.26-12.6595C26.0249.636 22.3315 0 16.0405 0h-.1269C9.5962 0 5.9272.6361 3.3298 3.1578.6813 5.8328.0698 9.5263.0698 15.8173v.1779c0 6.291.6115 9.9581 3.26 12.6596 2.5728 2.5217 6.2664 3.1577 12.5819 3.1577Z"/><path fill="#fff" d="M28.0936 15.6648c0-.1211-.0985-.2215-.2197-.2271-4.348-.1647-6.9942-.7193-8.8454-2.5706-1.8551-1.855-2.4079-4.5032-2.5726-8.8607a.2275.2275 0 0 0-.2271-.2195h-.5073c-.1211 0-.2215.0984-.2271.2195-.1647 4.3556-.7175 7.0057-2.5725 8.8607-1.8531 1.8532-4.4975 2.4059-8.8455 2.5706a.2276.2276 0 0 0-.2196.2271v.5073c0 .1212.0984.2215.2196.2272 4.348.1646 6.9942.7193 8.8455 2.5705 1.8512 1.8513 2.404 4.492 2.5706 8.8322a.2276.2276 0 0 0 .2271.2197h.5092c.1211 0 .2215-.0985.2271-.2197.1666-4.3402.7194-6.9809 2.5707-8.8322 1.8531-1.8531 4.4974-2.4059 8.8454-2.5705a.2277.2277 0 0 0 .2197-.2272v-.5073h.0019Z"/></g></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </card-background>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import CardBackground from '@/components/UI/card/CardBackground.vue';
import Button from '@/components/KazUI/atoms/button'
import Avatar from '@/components/KazUI/atoms/avatar'
import Tabs from '@/components/KazUI/atoms/tabs'
import KazDropdown from '@/components/KazUI/slots/dropdown'
import TabsNavigation from '@/components/KazUI/atoms/tabsNavigation'
import KazBadge from '@/components/KazUI/atoms/badge'
import SearchBookInput from '@/components/common/SearchBookInput.vue';

import { fetchMethodData } from "@/utils/loaders.js";
import { RegistrationClient } from "@/generated/user/registration_grpc_web_pb.js";

import subHeaderArray from '../SubHeaderComponent/components/utils';


var intersectionObserver = null;


export default {
  name: 'header-common',

  components: {
    CardBackground,
    Button,
    Avatar,
    Tabs,
    KazDropdown,
    TabsNavigation,
    KazBadge,
    SearchBookInput
  },

  data() {
    return {
      subHeaderArray,
      dropdownItems:[
        {
          title: 'Настройки',
          action: this.goToSettings
        },
        {
          title: 'Выход',
          action: this.logout
        }
      ],
      burgerVisibility: true,
      windowWidth: window.innerWidth,
    };
  },

  methods:{
    ...mapActions({
      createTokenState: 'authData/createState',
      openLoginPopup: 'popupAuth/openLoginPopup'
    }),


    openPopupRegistration() {
      this.openLoginPopup();
    },

    goToSettings(){
      this.$router.push('/profile')
    },

    goToLogin(){
      this.$router.push('/login')
    },

    changeTab(tabIndex) {
      this.$router.push(this.navItems[tabIndex].link);
    },

    toggleMenu(){
      this.burgerVisibility = !this.burgerVisibility
    },

    isLinkActive(link) {
      const hasIncluded = this.$route.matched.some(route => link?.included?.includes(route.name));
      const hasExcluded = link?.excluded?.includes(this.$route.name);
      return hasIncluded && !hasExcluded
    },

    async logout() {
      try {
        const registrationService = new RegistrationClient(
          process.env.VUE_APP_REGISTRATION_SERVICE_URL, 
          null, 
          null
        );
        const requestLogout = new proto.google.protobuf.Empty();
        const tokens = this.$getTokenInfo();
        const metadata = { 'token': tokens.accessToken.token };
        await fetchMethodData(
          registrationService,
          'logout',
          { request: requestLogout, metadata }
        );
        await this.resultHandlerLogout();
      } catch (e) {
        console.error('Logout:', e);
        await this.resultHandlerLogout(e);
      } finally {
        this.$router.push('/login');
      }
    },
    async resultHandlerLogout(err) {
      if (err) {
        let errMsg = null;
        let isAlert = false;
        switch (err.code) {
          case 2:
            errMsg = 'Сервис недоступен\n' + err.message;
            isAlert = true;
            break;
          case 14:
            errMsg = 'Сервис регистрации пользователей недоступен\n' + err.message;
            isAlert = true;
            break;
          default:
            errMsg = `Code: ${err.code}\n message: ${err.message}`;
          //isAlert = true;
        }
        console.error(errMsg);
        if (isAlert) {
          window.alert(errMsg);
        }
      } else {
        await this.createTokenState({
          accessToken: null,
          refreshToken: null,
          tokenTimeCreated: null,
          isRegistered: false
        });
      }
    },
    onWindowResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  computed: {
    ...mapGetters({
      getStudent: 'userData/getStudent',
      getSrcAvatar: 'userData/getSrcAvatar',
      sessionActive: 'authData/sessionActive',
    }),
    isPersonalInfoRoute() {
      return this.$route.path === '/profile';
    },
    isModerationRoute() {
      return this.$route.name.includes('moderation') || this.$route.path.includes('generation');
    },
    filteredSubHeaderArray() {
      return subHeaderArray.filter((item) => {
        if (this.sessionActive) {
          return item.authDisplay;
        } else {
          return item.noAuthDisplay;
        }
      });
    },
    showSearchBookWidget() {
      return true /*this.$route.name !== 'tasks'*/;
    }
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize);

    const searchBookAnchor = this.$refs['searchBookAnchor'];
    const searchBookInput = this.$refs['searchBookInput'];
    /*if (searchBookAnchor && searchBookInput) {
      intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          searchBookInput.classList.toggle('search-book-fixed', !entry.isIntersecting);
        }, 
        {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: 0.1
        }
      );
      intersectionObserver.observe(searchBookAnchor);
    }*/
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  },

  beforeUnmount() {
    if (intersectionObserver) {
      intersectionObserver.disconnect();
    }
  }
}
</script>

<style scoped>
.header {
  min-width: 0;
}

.header__wrapper{
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 32px 0px 32px;
}
.header__wrapper_padding{
  padding: 16px 32px;
}
.header__line{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.header__navigation{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid var(--kaz-base-base-04);
}
.navigation__item{
  margin-top: 16px;
  padding-bottom: 16px;
}
.navigation__item_badge{
  margin-top: 12px;
  padding-bottom: 12px;
}
.navigation__item p{
  color: var(--kaz-textIcons-text-02);
  transition: var(--kaz-transition-molecules);
}

.navigation__item_active{
  border-bottom: 2px solid var(--kaz-base-primary);
}
.navigation__item_active p{
  color: var(--kaz-textIcons-text-01);
  transition: var(--kaz-transition-molecules);
}
.navigation__item:hover p{
  color: var(--kaz-textIcons-text-01);
  transition: var(--kaz-transition-molecules);
}
.label, a{
  text-decoration: none;
}
.mobile__navigation{
  display: none;
}

.link{
  text-decoration: none;
}
.logo__wrapper{
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo{
  width: 32px;
  height: 32px;
}
.header__user-wrapper{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
.avatar{
  cursor: pointer
}
.menu{
  display: none;
}
.header__line_mobile{
  display: none;
}
.login__button{
  display: block;
}
.search-book-fixed {
  position: fixed;
  top: 16px;
  right: 0;
  left: 0;
  padding: 16px;
  background: var(--kaz-base-base-01);
  box-shadow: 4px 0px 16px 0px rgba(74, 74, 74, 0.15);
  border-radius: 8px;
  z-index: 1000;
}
.search-book-fixed > div {
  margin: 0 auto;
}

.header__search-wrapper_mobile {
  display: none;
}

.header__info,
.header-soc {
  display: flex;
  align-items: center;
}

.header-soc_mobile {
  display: none;
}

.header__info {
  gap: 32px;
}

.header-soc {
  gap: 16px;
}

.header-soc__link {
  display: inline-block;
  width: fit-content;
  color: #191C30;
  transition: color var(--kaz-transition-molecules);
}

.header-soc__link:hover {
  color: var(--kaz-base-accent);
}

@media screen and (max-width: 1200px) {
  .header__search {
    flex-direction: column;
    align-items: flex-start;
  }
  .header__search-wrapper {
    align-self: center;
    margin: 8px 0;
  }
}


@media screen and (max-width: 768px) {

  .dropdown__item_type_divider{
    display: none;
  }
  .header__line:last-of-type{
    display: none;
  }
  .header__wrapper{
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
  }
  .header__user-wrapper{
    gap: 16px;
  }
  .menu{
    display: block;
  }
  .menu__wrapper{
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .header__navigation{
    display: none;
  }
  .header__line{
    gap: 16px;
  }
  .header__line_mobile{
    display: flex;
    gap: 16px;
  }
  .login__button{
    display: none;
  }

  .mobile__navigation {
    display: flex;
    flex-direction: row;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 8px;
  }

  .mobile__navigation > a {
    flex-shrink: 0;
  }
  
  .navigation__item{
    margin: 0;
    padding: 8px;
  }
  .navigation__item p{
    color: var(--kaz-textIcons-text-02);
  }
  .navigation__item_active{
    border-radius: 4px;
    border: none;
    background-color: var(--kaz-textIcons-link-bg);
  }
  .navigation__item_active p{
    color: var(--kaz-textIcons-link);
  }
  .button__exit{
    width: fit-content;
  }
  .navigation__item_badge{
    margin: 0;
  }
  .header__search-wrapper {
    display: none;
  }
  .header__search-wrapper_mobile {
    display: block;
    align-self: center;
  }
  .header-soc {
    display: none;
  }
  .header-soc_mobile {
    display: flex;
    justify-content: center;
  }
}

@media screen and (max-width: 568px) {
  .header__search-wrapper_mobile {
    align-self: initial;
  }
}
</style>
